import { render } from "./BesinciTeker.vue?vue&type=template&id=582bed6b"
import script from "./BesinciTeker.vue?vue&type=script&lang=js"
export * from "./BesinciTeker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__